import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "common-arrow_down",
  "use": "common-arrow_down-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"common-arrow_down\"><path d=\"M10 5V15M10 15L5 10M10 15L15 10\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol